import React from 'react';
import { Link } from 'react-router-dom';


const BookingFailed = () => {
  return (
    <div className="container d-flex align-items-center justify-content-center">
      <div className="card shadow-lg text-center p-4" style={{ maxWidth: '500px', width: '100%' }}>
        <div className="card-body">
          <div className="mb-4">
            <i className="bi bi-x-circle text-danger" style={{ fontSize: '4rem' }}></i>
          </div>
          <h2 className="card-title text-danger">Booking Failed</h2>
          <p className="card-text">
            We're sorry, your booking could not be completed due to a payment error or invalid details.
          </p>
          <div className="d-grid gap-2 mt-4">
            <Link to="/" className="btn btn-outline-secondary">Go to Home</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingFailed;
